import { render, staticRenderFns } from "./CustomerNextAppointmentCard.vue?vue&type=template&id=3f184106&"
import script from "./CustomerNextAppointmentCard.vue?vue&type=script&lang=js&"
export * from "./CustomerNextAppointmentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports